import React, {useEffect, useRef} from 'react'
import Workspace from "components/Workspace";
import ContractPerformingNoticeForm from "components/complex/nationalNotice/contractPerformingNotice/ContractPerformingNoticeForm";

function NoticeAgreementPanel({match, location, history}) {
    const formType = match.params.formType;
    const demandId = match.params.id;
    const agreementId = match.params.agreementId;
    const noticeId = match.params.noticeId;

    const params = new URLSearchParams(location.search);
    const partsId = (params.get("partsId") || "").split(",").filter(Boolean);
    
    const autoCreateVersionIntentRef = useRef(null);
    if (autoCreateVersionIntentRef.current === null) {
        autoCreateVersionIntentRef.current =
            new URLSearchParams(location.search).get("autoCreateVersion") === "1";
    }
    const autoCreateVersionIntent = autoCreateVersionIntentRef.current;

    useEffect(() => {
        const p = new URLSearchParams(location.search);
        if (p.get("autoCreateVersion") !== "1") return;

        p.delete("autoCreateVersion");
        const nextSearch = p.toString();
        history.replace({
            pathname: location.pathname,
            search: nextSearch ? `?${nextSearch}` : ""
        });
    }, [history, location.pathname, location.search]);
    
    switch (formType) {
        case "contractPerformingNotice":
        default:
            return (
                <Workspace
                    render={<ContractPerformingNoticeForm
                        demandId={demandId}
                        agreementId={agreementId}
                        noticeId={noticeId}
                        positionIds={partsId}
                        autoCreateVersion={autoCreateVersionIntent}
                    />}
                />
            )
    }
}

export default NoticeAgreementPanel;
